// Daily-challenge streak tracker (localStorage only).
// A streak counts consecutive UTC days on which the player completed
// at least one daily-challenge run.

const STORAGE_KEY = "ppe_daily_streak_v1";
// Shape: { streak: number, lastPlayedDate: "YYYY-MM-DD" }

function todayUtc() {
  return new Date().toISOString().slice(0, 10);
}

function yesterdayUtc() {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

function read() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

function write(v) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(v));
  } catch {}
}

// Returns { streak, lastPlayedDate, atRisk } — atRisk = true means yesterday
// was played but today has not been (streak will break if not played).
export function getStreak() {
  const data = read() || { streak: 0, lastPlayedDate: null };
  const today = todayUtc();
  const yest = yesterdayUtc();
  const atRisk = data.lastPlayedDate === yest && data.streak > 0;
  // If the last play was before yesterday, the streak is effectively broken
  const effective = data.lastPlayedDate === today || data.lastPlayedDate === yest ? data.streak : 0;
  return { streak: effective, lastPlayedDate: data.lastPlayedDate, atRisk };
}

import { consumeFreeze, getFreezes } from "@/lib/chips";

// Call after a daily-challenge run finishes (win or lose). Returns { streak, freezeUsed }.
export function bumpStreakOnDailyRun() {
  const today = todayUtc();
  const yest = yesterdayUtc();
  const data = read() || { streak: 0, lastPlayedDate: null };
  let next;
  let freezeUsed = false;
  if (data.lastPlayedDate === today) {
    next = data.streak; // already counted today
  } else if (data.lastPlayedDate === yest) {
    next = data.streak + 1; // consecutive day
  } else if (data.streak > 0 && getFreezes() > 0) {
    // The streak *would* break — spend a freeze to save it and continue counting.
    consumeFreeze();
    freezeUsed = true;
    next = data.streak + 1;
  } else {
    next = 1; // reset / new streak
  }
  write({ streak: next, lastPlayedDate: today });
  return { streak: next, freezeUsed };
}
